import { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useParams } from 'react-router-dom';
import matter from 'gray-matter';
import blogPostData from '../data/blog.json';
import SEO from '../components/SEO';
import NewsletterSubscription from '../components/NewsletterSubscription';

const Article = () => {
  const [content, setContent] = useState('');
  const { slug } = useParams();
  const [imageUrl, setImageUrl] = useState()
  const [title, setTitle] = useState()
  const [articleTags, setTags] = useState()
  const blogPosts = blogPostData;

  useEffect(() => {
    // Scroll to top when component mounts or slug changes
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // extract details of the blog article from meta object
    const metadata = blogPosts.filter(x=>x.slug === slug);
    setImageUrl(metadata[0].image);
    setTitle(metadata[0].title || "paca-dev article" )
    setTags(metadata[0].tags || "")

    fetch(`/blog/${slug}.md`)
      .then((res) => {
        if (!res.ok) throw new Error(`Article not found ${slug}.md`);
        return res.text();
      })
      .then((text) => {
        const { data, content } = matter(text);
        setContent(content);
      })
      .catch((error) => {
        console.error(error);
        setContent(`Article not found.`)
      });
  }, [slug]);

  return (
    <>
      <SEO
          title={"paca-dev-"+ title }
          image={imageUrl}
          keywords={articleTags? articleTags.join(','): "" }
        />
        <div className="max-w-4xl mx-auto px-6 py-10 prose prose-lg prose-indigo">
          {imageUrl && (
            <img
              src={imageUrl}
              alt={title || 'Article image'}
              className="mb-10 rounded-lg shadow-lg max-w-full h-auto"
            />
          )}

          <ReactMarkdown remarkPlugins={[remarkGfm]} >{content}</ReactMarkdown>
        </div>
        
        {/* Newsletter */}
        <NewsletterSubscription />
    </>
  );

};

export default Article;
